import { render, staticRenderFns } from "./AccountDrawer.vue?vue&type=template&id=a23dd5fc&scoped=true&"
import script from "./AccountDrawer.vue?vue&type=script&lang=js&"
export * from "./AccountDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AccountDrawer.vue?vue&type=style&index=0&id=a23dd5fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dd5fc",
  null
  
)

export default component.exports